import { Directive, Input, inject } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from "@angular/forms";
import { DatepickerComponent } from "~app/common/components/datepicker/datepicker.component";
import { DateUnionType } from "~app/common/utils/date-utils";
import { DateValidators } from "../validators/date-validators";

@Directive({
    selector: "rask-datepicker[raskMinDate]",
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: MinDateDirective,
            multi: true
        }
    ]
})
export class MinDateDirective implements Validator {
    private readonly datePicker = inject(DatepickerComponent);

    private _raskMinDate: DateUnionType = null;

    constructor() {
        this.datePicker.allowInvalidInput = true;
    }

    @Input()
    set raskMinDate(value: DateUnionType) {
        this._raskMinDate = value;
        this.datePicker.minDate = value;
    }

    validate(control: AbstractControl<any, any>): ValidationErrors {
        return DateValidators.minDate(this._raskMinDate)(control);
    }
}
